import React from 'react';
import { PropTypes } from 'prop-types';


const MessageParser = ({ children, actions}) => {
    console.log(actions);
    
    const parse = (message) => {
        actions.handleOther(message);
    }

    return (
        <div>
            {React.Children.map(children, (child) => {
                return React.cloneElement(child, {
                    parse: parse,
                    actions: {}
                });
            })}
        </div>
    );
};

MessageParser.propTypes = {
  children: PropTypes.object,
  actions: PropTypes.object,
};

export default MessageParser;